const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaTipo: [],
	filtro: {}
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'LAUDO_OCORRENCIA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'LAUDO_OCORRENCIA_FILTRO':
			return {
				...state,
				filtro: action.payload
			}

		case 'LAUDO_OCORRENCIA_TIPO_SELECT_LISTADO':
            return { ...state,
				listaTipo: action.payload.data
			};

        case 'LAUDO_OCORRENCIA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

        default:
            return state;
    }
}
